$(function () {
	if ($('.jq_sticky_event').length) {
		var stickyObserver = new IntersectionObserver(function(items) {
			$.each(items, function(i, item) {
				$(item.target).toggleClass('is-sticky', item.intersectionRatio < 1);
			});
		}, {
			threshold: [1]
		});

		$('.jq_sticky_event').each(function() {
			stickyObserver.observe(this);
		});
	}
});
